export class UserData {
  friendlyName: string;
  email: string;
  language: string;
  domainName?: string;
  domainType?: DomainType;
  isSetPin?: boolean;
}

export class PreferenceRequest {
  source: UserPreferenceSourceType;
  key: string;
  value?: string;
}

export class PreferenceResponse {
  preference: string;
  sourceId: number;
  userId: number;
  value: string;
}

export class UserLanguageRequest {
  language: string;
}

export class UserPasswordRequest {
  password: string;
  newPassword: string;
}

export class UserSignProfileRequest {
  source: UserPreferenceSourceType;
  key: string;
  value?: string;
}
export class UserSignProfileResponse {
  signatureImageData: UserSignatureImageResponse;
  userPreferenceData: UserPreferenceDataResponse;
}

export class UserPreferenceDataResponse {
  key: string;
  value: string;
}

export class PinResponse {}

export class UserPinRequest {
  currentUserPin: string;
  userPin: string;
}

export class CreateUserPinRequest {
  userPin: string;
  action: string;
}
export class CodeUserPinRequest extends CreateUserPinRequest {
  code: string;
}

export class UserSignatureImageResponse {
  signatureImage: string;
  username: string;
  imageExtension: string;
}

export class UserPreferenceListConfig {
  orderBy: string;
  orderMode: string;
  pageSize: number;
}

export class SpConfig {
  driveId: string;
  driveItemId: string;
  mode: string;
  suffix: string;
  parentRefId?: string;
}

export class UserPinConfig {
  dn: string;
  dt: DomainType;
  op: string;
  c: string;
}

export enum DomainType {
  ActiveDirectory = 'AD1',
  LocalUsers = 'LU1',
  LDAP = 'LD1',
  ActivationCode = 'AC1',
  SAML2 = 'SAML2',
  OAUTH2 = 'OAuth2',
  Certificate = 'CU1'
}

export enum UserPreferenceSourceType {
  All = 'All',
  AdminConsole = 'AdminConsole',
  PersonalArea = 'PersonalArea',
  Agent = 'Agent'
}

export enum PinMode {
  NoPIN = 'NoPIN',
  CertPIN = 'CertPIN',
  UserPIN = 'UserPIN'
}

export enum AuthUserPinType {
  SET = 'SetPin',
  RESET = 'RecoverPin'
}

export enum Permission {
  DOCUMENT_SIGNATURE = 'DOCUMENT_SIGNATURE',
  UPLOAD_CERTIFICATES = 'UPLOAD_CERTIFICATES',
  CHANGE_PASSWORD = 'CHANGE_PASSWORD',
  CHANGE_NAME = 'CHANGE_NAME',
  CHANGE_EMAIL = 'CHANGE_EMAIL',
  WEB_SIGNATURE = 'WEB_SIGNATURE',
  SHAREPOINT = 'SHAREPOINT_USAGE'
}

export enum Module {
  DSS = 'DSS',
  SIGNATURE_MANAGER = 'SIGNATURE_MANAGER',
  EXTERNAL_DOMAINS = 'EXTERNAL_DOMAINS',
  SSL = 'SSL',
  FNMT = 'FNMT',
  FP = 'FP',
  PRESERVATION = 'PRESERVATION',
  WEB_SIGNATURE = 'WEB_SIGNATURE',
  SHAREPOINT = 'SHAREPOINT_INTEGRATION'
}
// SIGNTRUST PROFILE ENDPOINTS MIGRATION:
export class SignatureProfile {
  hasSelectedCert: boolean;
  selectedCertId: number;
  includeImage: boolean;
  includeInfo: boolean;
  infoItems: InfoItems[];
  pageType: PageType;
  pageRange: string;
}

export enum InfoItems {
  CERTIFICATE = 'CERTIFICATE',
  FRIENDLYNAME = 'FRIENDLYNAME',
  DATE = 'DATE',
  THUMBPRINT = 'THUMBPRINT'
}

export enum PageType {
  CURRENT = 'CURRENT',
  LAST = 'LAST',
  ALL = 'ALL',
  RANGE = 'RANGE'
}

export class SignatureImage {
  imageInBase64: string;
}

export class SignatureLastPosition {
  x: number;
  y: number;
  width: number;
  height: number;
  rotationDegrees: number;
}
